import { render, staticRenderFns } from "./CatalogDashboard.vue?vue&type=template&id=3c486304&scoped=true"
import script from "./CatalogDashboard.vue?vue&type=script&lang=js"
export * from "./CatalogDashboard.vue?vue&type=script&lang=js"
import style0 from "./CatalogDashboard.vue?vue&type=style&index=0&id=3c486304&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c486304",
  null
  
)

export default component.exports